<template>
    <div class="rain-pipe-detection">
        <div class="card">
            <div class="header">
                <div class="title">
                    <div class="decorate"></div><div> 管网健康状况分析</div>
                </div>
            </div>
            <div class="body">
                <div class="justify-center" style="height: 12vh;">
                    <div class="chart" style="height: 16vh;width: 20%;margin-left: -0.5vw; flex: 1" id="waterConditionWarn"></div>
                    <div class="pipe-diameter-score">
                        <div class="title-score">管网健康综合评分</div>
                        <div class="justify-center" style="align-items: center">
                            <div class="pipe-score-Num">78</div><div class="pipe-score-unit">分(良好)</div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="pipe-score-container">
                        <div class="pipe-score-info">
                            <div class="pipe-score-info-content">
                                <div class="pipe-score-info-image">
                                    <img style="width:2.5vw;height: auto;border-radius: 50%;" src="/index/structure.png"/>
                                </div>
                                <div class="pipe-score-info-details">
                                    <div class="score"><div>82</div><div>分</div></div>
                                    <div>结构完整</div>
                                </div>
                            </div>
                        </div>
                        <div class="pipe-score-info">
                            <div class="pipe-score-info-content">
                                <div class="pipe-score-info-image">
                                    <img style="width:2.5vw;height: auto;border-radius: 50%;" src="/index/drainage.png"/>
                                </div>
                                <div class="pipe-score-info-details">
                                    <div class="score"><div>86</div><div>分</div></div>
                                    <div>排水能力</div>
                                </div>
                            </div>
                        </div>
                        <div class="pipe-score-info">
                            <div class="pipe-score-info-content">
                                <div class="pipe-score-info-image">
                                    <img style="width:2.5vw;height: auto;border-radius: 50%;" src="/index/time.png"/>
                                </div>
                                <div class="pipe-score-info-details">
                                    <div class="score"><div>78</div><div>分</div></div>
                                    <div>管龄评分</div>
                                </div>
                            </div>
                        </div>
                        <div class="pipe-score-info">
                            <div class="pipe-score-info-content">
                                <div class="pipe-score-info-image">
                                    <img style="width:2.5vw;height: auto;border-radius: 50%;" src="/index/defect.png"/>
                                </div>
                                <div class="pipe-score-info-details">
                                    <div class="score"><div>12</div><div>公里</div></div>
                                    <div>缺陷管网</div>
                                </div>
                            </div>
                        </div>
                        <div class="pipe-score-info">
                            <div class="pipe-score-info-content">
                                <div class="pipe-score-info-image">
                                    <img style="width:2.5vw;height: auto;border-radius: 50%;" src="/index/operations.png"/>
                                </div>
                                <div class="pipe-score-info-details">
                                    <div class="score"><div>23</div><div>公里</div></div>
                                    <div>运维管网</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="header">
                <div class="title">
                    <div class="decorate"></div><div> 管网检测信息</div>
                </div>
            </div>
            <div class="body">
                <div>
                    <div class="emergency">
                        <div class="emergency-subtitle"></div>
                        <div>
                            <div class="site-title">
                                <div>项目</div><div>已检测公里数</div>
                                <div>未检测公里数</div><div>缺陷管网个数</div>
                            </div>
                            <div style="height: 27vh; overflow: hidden;">
                                <div v-for="(item, index) in List" :key="index"  class="site-list">
                                    <div>{{item.project}}</div><div>{{item.tested}}</div>
                                    <div>{{item.undetected}}</div><div>{{item.flawNum}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
    TooltipComponent,
    TitleComponent,  // 新增：标题组件
    GridComponent    // 新增：网格组件
} from "echarts/components";
// 补充缺失的图表类型导入
import {
    PieChart,
    CustomChart,     // 新增：自定义图表
    BarChart,        // 新增：柱状图
    PictorialBarChart // 新增：象形柱图
} from "echarts/charts";
import {LabelLayout} from "echarts/features";
import {CanvasRenderer} from "echarts/renderers";

echarts.use([
    TooltipComponent,
    TitleComponent,
    GridComponent,
    PieChart,
    CustomChart,
    BarChart,
    PictorialBarChart,
    CanvasRenderer,
    LabelLayout
]);
export default {
    name: "riverWaterQuality",
    data(){
        return{
            riverWaterList:[
                {name:'I类',value:18.0},{name:'II类',value:14.0},
                {name:'III类',value:5.0},{name:'IV类',value:3.0},
                {name:'V类',value:2.0},{name:'劣V类',value:2.0},
                {name:'暂无数据',value:1.0},
            ],
            List:[
                {project:'宝山东路',tested:'3',undetected:'71',flawNum:'74'},
                {project:'宝山路',tested:'0',undetected:'0',flawNum:'16'},
            ]
        }
    },
    mounted() {
        this.initriverWaterQualityChart();
        setTimeout(() => this.startScrolling(), 1000);
    },
    methods: {
        beforeUnmount() {
            if (this.scrollTimer) clearInterval(this.scrollTimer);
        },
        startScrolling() {
            if (this.scrollTimer) clearInterval(this.scrollTimer);
            this.scrollTimer = setInterval(() => {
                const firstItem = this.List[0];
                this.List = [...this.List.slice(1), firstItem];
            }, 2000);
        },
        initriverWaterQualityChart() {
            const chartDom = document.getElementById("waterConditionWarn");
            if (!chartDom) return;
            this.sewageChart = echarts.init(chartDom);
            let value = 78;
            var option;
            option = {
                title: {
                    text: '{a|'+ value +'}{c|%}',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        rich:{
                            a: {
                                fontSize: 24,
                                color: '#29EEF3'
                            },
                            c: {
                                fontSize: 18,
                                color: '#ffffff'
                            }
                        }
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['78%', '65%'],
                        silent: true,
                        clockwise: true,
                        startAngle: 360*0.6/2+90,
                        z: 0,
                        zlevel: 0,
                        label: {
                            normal: {
                                position: "center",
                            }
                        },
                        data: [{
                            value: value,
                            name: "",
                            itemStyle: {
                                normal: {
                                    color: {
                                        colorStops: [{
                                            offset: 0,
                                            color: '#4FADFD'
                                        }, {
                                            offset: 1,
                                            color: '#28E8FA'
                                        }]
                                    },
                                }
                            }
                        },
                            {
                                value: 100/0.6-100/0.6*0.4-value,
                                name: "",
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: "#173164"
                                    }
                                }
                            },
                            {
                                value: 100/0.6*0.4,
                                name: "",
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: "rgba(0,0,0,0)"
                                    }
                                }
                            }
                        ]
                    },
                    {
                        name: "",
                        type: "gauge",
                        radius: "62.7%",
                        center: ['50%', '50%'],
                        startAngle: 0,
                        endAngle: 180,
                        splitNumber: 5,
                        hoverAnimation: true,
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            length: 64,
                            lineStyle: {
                                width: 5,
                                color: "#061740"
                            }
                        },
                        axisLabel: {
                            show: false
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                opacity: 0
                            }
                        },
                        detail: {
                            show: false
                        },
                        data: [{ value: 0, name: "" }]
                    }
                ]
            };
            option && this.sewageChart.setOption(option);
        },
    }
}
</script>

<style scoped>
.rain-pipe-detection{
    position: absolute;
    z-index: 1000;
}


.card {
    background:var(--card-color);
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    margin-left: 1vw;
    width: 22vw;
    .pipe-diameter-pump{
        display: flex;
        justify-content: space-between;
    }


    .decorate{
        margin:0 10px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-bottom: 5px solid #00ff96;
        position: relative;
        top: -5px;
    }
    .decorate:after {
        content: '';
        position: absolute;
        left: -5px;
        top: 5px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top: 5px solid #00ff96;
    }

    & > .header {
        margin-top:10px;
        background: url("../../../assets/dashboard/cardTitleBg.png")  no-repeat;
        background-size: 100%;
        padding:0 15px;
        color: #fff;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 4vh;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .title{
        display:flex;
        justify-content: center;
        align-items: center;
    }

    .body {
        padding: 1.4vh 1vw;
        color: #f3f3f3;

    }

    .extra{
        display: flex;
        align-items: center;
    }

}


.justify-center{
    display: flex;
    justify-content: start;
    /*align-items: center;*/
}
.pipe-diameter-score{
    padding: 1rem;
    width: 60%;
    .title-score{
        font-size: 1rem;
        /*font-weight: bold;*/
        color: #d1d1d1;
    }
    .pipe-score-Num{
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.5vw;
        font-family: YouSheBiaoTiHei;
        background: linear-gradient(135deg, #ffa700, #ff9900);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .pipe-score-unit{
        font-size: 0.8vw;
        /*font-family: YouSheBiaoTiHei;*/
        color: #fff;
    }
}

.score{
    display: flex;
    justify-content: end;
    align-items: center;
    font-size: 0.8vw;
    font-family: YouSheBiaoTiHei;
    background: linear-gradient(135deg, #ffffff, #ffdeb6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.pipe-score-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 1vh 0;
}

.pipe-score-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 31.5%;
    margin: 0 0.1vw;
    margin-bottom: 2vh;
}

.pipe-score-info-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.pipe-score-info-image {
    display: flex;
    align-items: center;
    margin: 0 0 0 0.1vw;
}

.pipe-score-info-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 0.2rem;
    font-size: 0.8vw;
    color: #dedede;
}

.score {
    display: flex;
    align-items: center;
    font-size: 0.9vw;
    font-family: YouSheBiaoTiHei;
    background: linear-gradient(135deg, #f8f8f8, #ffdeb6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

}

/* 表格标题样式 */
.site-title {
    display: flex;
    width: 100%;
    font-size: 0.7vw;
    color: #00ff96;
    background: rgba(10, 20, 40, 0.6);
    border-bottom: 2px solid rgba(0, 255, 150, 0.3);
    padding: 0.8rem 0;
    white-space: nowrap;
}
/* 表格内容行样式 */
.site-list {
    display: flex;
    width: 100%;
    font-size: 0.7vw;
    padding: 0.6rem 0;
    border-bottom: 1px solid rgba(0, 255, 150, 0.1);
}
/* 统一列宽（4列平均分配） */
.site-title > div, .site-list > div {
    flex: 1;
    text-align: center;
    padding: 0 0.5rem;
}

</style>